export const PREF_ABRIR_CERRAR_SIDEBAR = 'PREF_ABRIR_CERRAR_SIDEBAR';
